import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo/logo.png" alt="S-CUBUS logo" className="footer-logo-image footer-logo-image--bare" />
            </div>
            <p className="footer-description">
              Premier coaching institute for Foundation, Olympiad, NEET, and JEE preparation.
            </p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/courses">Courses</Link></li>
              <li><Link to="/our-students">Results</Link></li>
              <li><Link to="/scholarship">Scholarship</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/philosophy">About Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>📧 Info@scubus.com</p>
              <p>📞 <a href="tel:+911146696001">+91 11 4669 6001</a></p>
              <p>
                Floor No.: Third Floor<br />
                Plot No. 46,<br />
                Road/Street: Sector 12B<br />
                Locality/Sub Locality: Dwarka<br />
                City/Pincode: New Delhi, 110078
              </p>
              <div className="footer-socials">
                <a
                  href="https://www.facebook.com/share/1FzuPEQd6q/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
                <a
                  href="https://www.instagram.com/s_cubus_dwarka?igsh=d2c5OXliNjVxcHF6&utm_source=qr"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
                <a
                  href="https://youtube.com/@s-cubus_dwarka_delhi?si=hnNRlZpAiMBTmhbc"
                  target="_blank"
                  rel="noreferrer"
                >
                  YouTube
                </a>
              </div>
            </div>
          </div>
        </div>

        <nav className="footer-programs" aria-label="Programmes in Dwarka">
          <div className="footer-col">
            <h4>JEE</h4>
            <ul className="footer-links">
              <li><a href="/jee-coaching-in-dwarka.html">JEE Coaching in Dwarka</a></li>
              <li><a href="/jee-main-coaching-in-dwarka.html">JEE Main Coaching</a></li>
              <li><a href="/jee-advanced-coaching-in-dwarka.html">JEE Advanced Coaching</a></li>
              <li><a href="/online-jee-coaching.html">Online JEE Coaching</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>NEET</h4>
            <ul className="footer-links">
              <li><a href="/neet-coaching-in-dwarka.html">NEET Coaching in Dwarka</a></li>
              <li><a href="/online-neet-coaching.html">Online NEET Coaching</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Foundation</h4>
            <ul className="footer-links">
              <li><a href="/foundation-coaching-in-dwarka.html">Foundation Coaching</a></li>
              <li><a href="/class-8-foundation-coaching.html">Class 8 Foundation</a></li>
              <li><a href="/class-9-foundation-coaching.html">Class 9 Foundation</a></li>
              <li><a href="/class-10-foundation-coaching.html">Class 10 Foundation</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Olympiad</h4>
            <ul className="footer-links">
              <li><a href="/olympiad-coaching-in-dwarka.html">Olympiad Coaching in Dwarka</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Subjects</h4>
            <ul className="footer-links">
              <li><a href="/physics-coaching-in-dwarka.html">Physics Coaching</a></li>
              <li><a href="/chemistry-coaching-in-dwarka.html">Chemistry Coaching</a></li>
              <li><a href="/biology-coaching-in-dwarka.html">Biology Coaching</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Learning modes</h4>
            <ul className="footer-links">
              <li><a href="/hybrid-jee-neet-coaching.html">Hybrid JEE / NEET Coaching</a></li>
            </ul>
          </div>
        </nav>

        <div className="footer-bottom">
          <p>© 2026 S-CUBUS CAREER PRIVATE LIMITED All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
